import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListEanvBgsUns extends GuiListGeneric {

    constructor() {
        super("EanvBgsUns");
    }

}
